/**
 * Переводы для пунктов главного меню в Header.
 * Используется в Header.consts.tsx через хелпер `getMenuTranslations(language)`.
 */

export type MenuTranslations = {
    autoTrading: string
    globalMarkets: string
    cryptoMarkets: string
    trade: string
    crypto: string
    global: string
    account: string
    staking: string
    referral: string
    partner: string
    partnerPanel: string
    clients: string
    partnerRequests: string
    premium: string
    guides: string
    accounts: string
    symbols: string
    advancedFutures: string
    fcm: string
    adminMenu: string
}

const translations: Record<string, MenuTranslations> = {
    en: {
        autoTrading: 'Exchanges',
        globalMarkets: 'Global markets',
        cryptoMarkets: 'Crypto markets',
        trade: 'Trade',
        crypto: 'Crypto',
        global: 'Global',
        account: 'Account',
        staking: 'Staking',
        referral: 'Referral',
        partner: 'Partner',
        partnerPanel: 'Partner',
        clients: 'Clients',
        partnerRequests: 'Partner Requests',
        premium: 'Premium',
        guides: 'Guides',
        accounts: 'Accounts',
        symbols: 'Symbols',
        advancedFutures: 'Advanced Futures',
        fcm: 'FCM',
        adminMenu: 'Admin',
    },
    ru: {
        autoTrading: 'Биржи',
        globalMarkets: 'Глобальные рынки',
        cryptoMarkets: 'Крипто рынки',
        trade: 'Торговля',
        crypto: 'Крипто',
        global: 'Глобальные',
        account: 'Личный кабинет',
        staking: 'Стейкинг',
        referral: 'Рефералы',
        partner: 'Партнёр',
        partnerPanel: 'Партнёр',
        clients: 'Клиенты',
        partnerRequests: 'Заявки партнёров',
        premium: 'Премиум',
        guides: 'Руководства',
        accounts: 'Аккаунты',
        symbols: 'Символы',
        advancedFutures: 'Advanced Futures',
        fcm: 'FCM',
        adminMenu: 'Админ',
    },
    es: {
        autoTrading: 'Exchanges',
        globalMarkets: 'Mercados globales',
        cryptoMarkets: 'Mercados cripto',
        trade: 'Operar',
        crypto: 'Cripto',
        global: 'Globales',
        account: 'Mi Cuenta',
        staking: 'Staking',
        referral: 'Referidos',
        partner: 'Socio',
        partnerPanel: 'Socio',
        clients: 'Clientes',
        partnerRequests: 'Solicitudes de Socio',
        premium: 'Premium',
        guides: 'Guías',
        accounts: 'Cuentas',
        symbols: 'Símbolos',
        advancedFutures: 'Advanced Futures',
        fcm: 'FCM',
        adminMenu: 'Admin',
    },
    fr: {
        autoTrading: 'Bourses',
        globalMarkets: 'Marchés globaux',
        cryptoMarkets: 'Marchés crypto',
        trade: 'Trader',
        crypto: 'Crypto',
        global: 'Globaux',
        account: 'Mon Compte',
        staking: 'Staking',
        referral: 'Parrainage',
        partner: 'Partenaire',
        partnerPanel: 'Partenaire',
        clients: 'Clients',
        partnerRequests: 'Demandes Partenaire',
        premium: 'Premium',
        guides: 'Guides',
        accounts: 'Comptes',
        symbols: 'Symboles',
        advancedFutures: 'Advanced Futures',
        fcm: 'FCM',
        adminMenu: 'Admin',
    },
    de: {
        autoTrading: 'Börsen',
        globalMarkets: 'Globale Märkte',
        cryptoMarkets: 'Krypto-Märkte',
        trade: 'Handeln',
        crypto: 'Krypto',
        global: 'Global',
        account: 'Mein Konto',
        staking: 'Staking',
        referral: 'Referral',
        partner: 'Partner',
        partnerPanel: 'Partner',
        clients: 'Kunden',
        partnerRequests: 'Partner-Anträge',
        premium: 'Premium',
        guides: 'Leitfäden',
        accounts: 'Konten',
        symbols: 'Symbole',
        advancedFutures: 'Advanced Futures',
        fcm: 'FCM',
        adminMenu: 'Admin',
    },
    it: {
        autoTrading: 'Exchange',
        globalMarkets: 'Mercati globali',
        cryptoMarkets: 'Mercati crypto',
        trade: 'Trading',
        crypto: 'Crypto',
        global: 'Globali',
        account: 'Il Mio Account',
        staking: 'Staking',
        referral: 'Referral',
        partner: 'Partner',
        partnerPanel: 'Partner',
        clients: 'Clienti',
        partnerRequests: 'Richieste Partner',
        premium: 'Premium',
        guides: 'Guide',
        accounts: 'Account',
        symbols: 'Simboli',
        advancedFutures: 'Advanced Futures',
        fcm: 'FCM',
        adminMenu: 'Admin',
    },
    hy: {
        autoTrading: 'Բորսաներ',
        globalMarkets: 'Գլոբալ շուկաներ',
        cryptoMarkets: 'Կրիպտո շուկաներ',
        trade: 'Առևտուր',
        crypto: 'Կրիպտո',
        global: 'Գլոբալ',
        account: 'Անձնական Կաբինետ',
        staking: 'Ստեյքինգ',
        referral: 'Ռեֆերալներ',
        partner: 'Գործընկեր',
        partnerPanel: 'Գործընկեր',
        clients: 'Հաճախորդներ',
        partnerRequests: 'Գործընկերության հայտեր',
        premium: 'Պրեմիում',
        guides: 'Ուղեցույցներ',
        accounts: 'Հաշիվներ',
        symbols: 'Սիմվոլներ',
        advancedFutures: 'Advanced Futures',
        fcm: 'FCM',
        adminMenu: 'Admin',
    },
}

export default translations
